import React from 'react';
import { Project } from "./types"
import "./ProjectCard.css"
import { Link, useNavigate } from "react-router-dom";


interface ProjectCardProps {
    project: Project;
    onClick?: any;
}

const ProjectCard = ({ project, onClick }: ProjectCardProps) => {

    return (<div className="window98-card">
        <div className="window98-title-bar">
            <span className="window98-title">{project.title + ".exe"}</span>
            <div className="window98-buttons">
                {/*<Link className="retro-button">?</Link>*/}
                <Link to={`/project/${project.id}`} className="retro-button">□</Link>
                {/*<span className="window98-button">×</span>*/}
                {project.hosted && project.hosted_link &&
                    <Link to={project.hosted_link} className={"retro-button"}>↗</Link>}
            </div>
        </div>


        <div className="window98-content">
            <img className="cover-img" src={project.cover_img.src} alt={project.cover_img.alt} />

            <div style={{ width: "100%", cursor: "pointer" }} className={"window"} onClick={onClick}>
                <h1>{project.title}</h1>
                <h2>{project.subtitle}</h2>
                <h3>{project.description}</h3>
                <div className={"tech-stack"}>
                    {project.technologies.map((tech, index) => (
                        <span key={index} className="retro-bubble">{tech}</span>
                    ))}
                </div>

                <div className="action-container">
                    {project.github_link && (
                        <a className="retro-button" href={project.github_link} target={"_blank"} rel="noreferrer">
                            Repo
                        </a>
                    )}
                    {project.hosted && (
                        <a className="retro-button" href={project.hosted_link} target={"_blank"} rel="noreferrer">
                            Visit site
                        </a>
                    )}
                </div>
            </div>

        </div>


    </div>

    );
};

export default ProjectCard;